<div class="row justify-content-center login">
  <div class="col-6 login-box">
    <div class="row image-container">
      <div class="col-12">
        <img src="../assets/images/Linkerweb_LogoFull_01.png" class="rounded mx-auto d-block" alt="..." >
      </div>
    </div>
    <div class="row credentials mt-5">
      <div class="col-8 offset-2 mb-3 text-center">
        <label for="inputPassword" class="form-label">Contraseña:</label>
        <input [(ngModel)]="password" #passwordModel="ngModel" type="password" id="inputPassword" class="form-control" aria-describedby="passwordHelpInline">
        @if (passwordModel.dirty && !hasMinLength) {
          <small class="d-block text-danger mt-1">La contraseña debe tener al menos 5 caracteres.</small>
        }
      </div>
      <div class="w-100"></div>
      <div class="col-8 offset-2 mb-3 text-center">
        <label for="inputRepeatedPassword" class="form-label">Repetir Contraseña:</label>
        <input [(ngModel)]="repeatedPassword" #repeatModel="ngModel" type="password" id="inputRepeatedPassword" class="form-control" aria-describedby="passwordHelpInline">
        @if (repeatModel.dirty && repeatedPassword.length > 0) {
          @if (passwordsMatch) {
            <small class="d-block text-success mt-1">Las contraseñas coinciden.</small>
          } @else {
            <small class="d-block text-danger mt-1">Las contraseñas no coinciden.</small>
          }
        }
      </div>
    </div>
    <div class="row pb-5 pt-3">
      <div class="col-6 d-grid gap-2 mx-auto">
        <button mat-flat-button color="primary" [disabled]="!canSubmit" (click)="validateUser()">Validar</button>
      </div>
    </div>
    <div class="row image-linker-web">
      <div class="col-12">
        <img src="../assets/images/Innovalinks_Logo_01.png" class="rounded mx-auto d-block" alt="..." >
      </div>
    </div>
  </div>
</div>
